module.exports = __webpack_public_path__ + "img/my_bizz.e33a3940.png";